<template>
  <div class="document-container">
    <div class="document">
      <div class="header">
        <EsHeader>
          <template #header>
            <div class="header-title">
              Rule Manager
            </div>
          </template>
        </EsHeader>
      </div>
      <div class="tabs no-bottom-border" v-if="hasModule('SYS:SYS:RULEMGR:VIEW')">
        <ul>
          <router-link
            v-for="link in ruleManagerLinks"
            :key="link.name"
            :to="{ name: link.routeName }"
            tag="li"
            replace
          >
            <a>{{ link.label }}</a>
          </router-link>
        </ul>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EsHeader from '@/components/EsHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
  ],
  components: {
    EsHeader,
  },
  created() {
    this.setBreadcrumb([
      {
        text: 'Rule Manager',
        to: {},
      },
    ]);
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
    // Dynamically generate the route names based on the active module
    ruleManagerLinks() {
      let routePrefix = '';
      if (this.activeModule && this.activeModule.name) {
        if (this.activeModule.name === 'personId') {
          routePrefix = 'Pid'; // For Person ID module
        } else if (this.activeModule.name === 'directMatch') {
          routePrefix = 'Dm'; // For Direct Match module
        } else if (this.activeModule.name === 'locationID') {
          routePrefix = 'Lid'; // For Location ID module
        }
      }
      // Return the route links with the appropriate route names
      return [
        {
          name: 'personId',
          label: 'PERSON ID',
          routeName: `${routePrefix}RuleManagerPersonId`,
        },
        // {
        //   name: 'directMatch',
        //   label: 'DIRECTMATCH',
        //   routeName: `${routePrefix}RuleManagerDirectMatch`,
        // },
      ];
    },
  },
};
</script>

<style lang="sass" scoped>
  .tabs
    padding: 1rem 1rem 0 1rem
</style>
